import React, { createContext, useContext } from "react";
import { useAuth, AuthProvider as OidcProvider } from "react-oidc-context";
import { oidcConfig } from "./oidcConfig";

export interface AuthContextProps {
  isAuthenticated: boolean;
  login: () => void;
  logout: () => void;
}

interface AuthProviderProps {
  children: React.ReactNode;
}

const AuthContext = createContext<AuthContextProps | undefined>(undefined);

const InternalAuthProvider = ({ children }: AuthProviderProps) => {
  const auth = useAuth();

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated: auth.isAuthenticated,
        login: auth.signinRedirect,
        logout: auth.signoutRedirect,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const AuthProvider = ({ children }: AuthProviderProps) => {
  return (
    <OidcProvider {...oidcConfig}>
      <InternalAuthProvider>{children}</InternalAuthProvider>
    </OidcProvider>
  );
};

export const useAuthContext = (): AuthContextProps => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuthContext must be used within an AuthProvider");
  }
  return context;
};